module.exports = __webpack_public_path__ + "static/img/12.3e6e6ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour4/12.jpg
// module id = B2Us
// module chunks = 0